// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"Ki","flipped":"Li","mainContentContainer":"Mi","cta":"Ni","mainContentCtaDefault":"Oi","disabled":"Pi","mainContentCtaWhite":"Qi"};